var GoogleMap = (function () {

    var $ = require('jquery');
    var self = {};

    self.map = $('.google-map');
    self.mapStyles = [];

    self.init = function () {

        if (self.map.length > 0) {

            var apiKey = self.map.data('api-key');

            //  Load External Lib
            $.ajax({
                url: '//maps.google.com/maps/api/js?sensor=false&key=' + apiKey,
                dataType: 'script',
                cache: true,
                success: function () {

                    //  It is possible to have multiple maps
                    self.map.each(function () {

                        var $this = $(this);

                        //  Settings from HTML
                        var dlatlng = $this.data('map-latlng');
                        var nlatlng = dlatlng.split(',');

                        //  Location
                        var latlng = new google.maps.LatLng(nlatlng[0], nlatlng[1]);

                        //  Map options
                        var options = {
                            center: latlng,
                            draggable: $this.data('map-draggable'),
                            zoom: $this.data('map-zoom'),
                            panControl: $this.data('map-pan-control'),
                            zoomControl: $this.data('map-zoom-control'),
                            mapTypeControl: $this.data('map-map-type-control'),
                            scaleControl: $this.data('map-scale-control'),
                            streetViewControl: $this.data('map-street-view-control'),
                            overviewMapControl: $this.data('map-overview-map-control'),
                            scrollwheel: $this.data('map-scrollwheel'),
                            styles: self.mapStyles
                        };

                        //  Initiate Map
                        var map = new google.maps.Map($this[0], options);

                        //  Add marker to Map
                        var icon = {
                            path: 'M19.5,0C8.7,0,0,8.8,0,19.6c0,13.4,17.5,33,18.2,33.9c0.7,0.8,1.9,0.8,2.6,0C21.5,52.6,39,32.9,39,19.6C39,8.8,30.3,0,19.5,0z M19.5,29.4c-5.4,0-9.8-4.4-9.8-9.8c0-5.4,4.4-9.8,9.8-9.8s9.8,4.4,9.8,9.8S24.9,29.4,19.5,29.4z',
                            fillColor: '#0096D0',
                            strokeWeight: 0,
                            fillOpacity: 1,
                            anchor: new google.maps.Point(20, 54),
                            scaledSize: new google.maps.Size(40, 54)
                        };

                        var marker = new google.maps.Marker({
                            position: latlng,
                            icon: icon,
                            map: map
                        });

                    });

                }
            });

        }

    };

    return self;

}());

module.exports = GoogleMap;
